import React from 'react'
import { SiFerrari } from "react-icons/si";

const Loading = () => {
    return (
        <div className='loading_screen'>
            <SiFerrari />
        </div>
    )
}

export default Loading